import React from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import ImageBW from '../../../../components/ImageBoundsWrapper';

const DefaultLevelUpText = () => {
  return (
    <div>
      <div className="levelUpTitle">{getText(TEXT_KEY.LEVEL_UP_TEXT)}</div>
      <ImageBW
        source={assetSource(ASSET_KEY.SHOP_VIP_DIVIDER_GLOWS)}
        ibw={require(asset`shop-vip-divider-glows.ibw`)}
        style={{
          width: '100%',
          height: '2.5rem',
          objectFit: 'contain',
          position: 'absolute',
        }}
      />
    </div>
  );
};

export default DefaultLevelUpText;

